export enum SearchesAction {
  UPDATE_PLAYERS_SEARCH_DATA = 'REPLACE_PLAYERS_SEARCH_DATA',
  UPDATE_COMBINE_PLAYERS_SEARCH_DATA = 'REPLACE_COMBINE_PLAYERS_SEARCH_DATA'
}

export type SearchesPlayersData = any[];

export type SearchesState = {
  playersData: SearchesPlayersData,
  playersCombineData:{
    [key:string]: SearchesPlayersData
  } 
}

interface UpdatePlayersSearchData {
  type: SearchesAction.UPDATE_PLAYERS_SEARCH_DATA,
  playersData: SearchesPlayersData
}



interface UpdateCombinePlayersSearchData {
  type: SearchesAction.UPDATE_COMBINE_PLAYERS_SEARCH_DATA,
  playersCombineData: SearchesPlayersData,
  teamId: string
}

export type SearchesActionTypes = UpdatePlayersSearchData | UpdateCombinePlayersSearchData;



